import { Link, useLocation } from 'react-router-dom';

import { Button, PageHeader } from '@/components';
import { landingPathFor, ROUTES } from '@/lib/routes';
import { useSession } from '@/lib/session';

/**
 * A 404 inside the app.
 *
 * Note what this page does NOT say: it does not distinguish "no such page"
 * from "a page you may not see". The API already answers 404 rather than 403
 * for a row outside the caller's scope, for the same reason - a different
 * answer would confirm the row exists.
 */
export default function NotFound() {
  const { status, user } = useSession();
  const location = useLocation();

  const home = status === 'authenticated' && user ? landingPathFor(user.role) : ROUTES.signIn;

  return (
    <>
      <PageHeader
        title="Nothing here"
        description="That address does not match anything in the portal."
      />

      <div className="max-w-xl rise">
        <p className="font-mono text-small text-subtle">
          <span className="text-muted">path</span> {location.pathname}
        </p>
        <p className="mt-4 text-ui text-muted">
          It may have been renamed, or it may belong to someone else's account. If you followed a
          link from somewhere inside the portal, that is worth mentioning - it means we have a stale
          link to fix.
        </p>
        <div className="mt-6 flex flex-wrap gap-2">
          <Button variant="primary" iconLeft="chevronLeft" onClick={() => window.history.back()}>
            Go back
          </Button>
          <Link to={home}>
            <Button variant="secondary">Take me home</Button>
          </Link>
        </div>
      </div>
    </>
  );
}
